export function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="cols">
          <div>
            <h4>Ensemble</h4>
            <p style={{ color: 'var(--ink-2)', maxWidth: 360, margin: 0 }}>Well-made clothes that go together. Designed in Brooklyn, worn everywhere.</p>
            <form className="news" onSubmit={e => e.preventDefault()}>
              <input className="input" placeholder="Email for 10% off your first order" aria-label="Email" />
              <button className="btn" type="submit">Join</button>
            </form>
          </div>
          <div><h4>Help</h4><ul><li>Orders & shipping</li><li>Returns & exchanges</li><li>Size guide</li><li>Contact us</li></ul></div>
          <div><h4>Company</h4><ul><li>About Ensemble</li><li>Sustainability</li><li>Stores</li><li>Careers</li></ul></div>
          <div><h4>Follow</h4><ul><li>Instagram</li><li>Pinterest</li><li>TikTok</li></ul></div>
        </div>
        <div className="legal">
          <span>© {new Date().getFullYear()} Ensemble Apparel Co. All rights reserved.</span>
          <span>Privacy · Terms · Accessibility</span>
        </div>
      </div>
    </footer>
  )
}
